import React from "react"
import {Paper, Typography} from "@material-ui/core";

const SidebarItem = ({ title, image}) => {
    return (
        <Paper className="sidebar-item">
            <img src={image} alt={title} />
            <Typography>{title}</Typography>
        </Paper>
    )
}

export default SidebarItem